<template>
    <v-card-text class="pb-0">
        <v-form ref="loginForm"
                @keyup.enter="tryToEnter"
                @submit.prevent>
            <v-text-field autofocus
                          clearable
                          v-model.trim="login"
                          :rules="loginRules"
                          name="login"
                          label="Логин/Email"
                          placeholder="Логин/Email"
                          autocomplete="username"
                          type="text"
                          prepend-icon="mdi-account" />

            <v-text-field clearable
                          v-model="password"
                          :rules="passwordRules"
                          name="password"
                          label="Пароль"
                          placeholder="Пароль"
                          autocomplete="current-password"
                          :type="showPassword ? 'text' : 'password'"
                          @click:prepend="showPassword = !showPassword"
                          :prepend-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" />

            <div class="text-error font-weight-bold mt-1 mb-3 ml-10"
                 v-if="errorMessage">{{ errorMessage }}</div>
        </v-form>

        <slot></slot>
    </v-card-text>

    <v-card-actions class="py-0">
        <v-checkbox class="pl-2"
                    v-model="rememberMe"
                    label="Запомнить?" />
        <v-spacer />
        <v-btn class="mr-2"
               variant="elevated"
               :disabled="!isValid"
               @click="tryToEnter"
               color="primary">Войти</v-btn>
    </v-card-actions>
</template>

<script>
    import DataValidator from "@/common/dataValidator";

    export default {
        data() {
            return {
                login: null,
                password: null,
                rememberMe: false,
                showPassword: false,

                isValidForm: false,
                errorMessage: "",

                loginRules: DataValidator.getLoginRules()
            };
        },

        computed: {
            passwordRules() {
                return DataValidator.getPasswordRules(this.passwordOptions);
            },
            passwordOptions() {
                return this.$store.state.passwordOptions;
            },

            isComplete() {
                return this.login && this.password;
            },
            isValid() {
                if (this.isComplete) {
                    this.validateForm();
                }

                return this.isComplete && this.isValidForm;
            }
        },

        methods: {
            async validateForm() {
                if (!this.$refs.loginForm) {
                    return;
                }

                const { valid } = await this.$refs.loginForm.validate();

                this.isValidForm = valid;
            },

            tryToEnter() {
                if (!this.isValid) {
                    return;
                }

                this.$store.dispatch("login", {
                    email: this.login,
                    password: this.password,
                    rememberMe: this.rememberMe
                }).then(response => {
                    if (response.data.isSuccess) {
                        window.location.href = "/";
                        return;
                    }

                    this.errorMessage = response.data.message;
                });
            }
        }
    };
</script>